export default __webpack_public_path__ + "static/media/image.e22d1731.svg";